var splides = document.querySelectorAll('.splide__003');
splides.forEach(function (splideElement, index) {
  new Splide(splideElement, {
  autoplay: false, // 自動再生
  type: "slide", 
  pagination: false,
  focus: "left",
  pauseOnHover: false, // カーソルが乗ってもスクロールを停止させない
  pauseOnFocus: false, // 矢印をクリックしてもスクロールを停止させない
  interval: 2000, // 自動再生の間隔
  speed: 1000, // スライダーの移動時間
  perPage: 2,
  gap: 10, // スライド間の余白
  arrows: true, // 矢印ボタンを非表示
  breakpoints: {
    749: {
      perPage: 1, // 500px未満の表示枚数
      gap: 20, // スライド間の余白
    },
  },
}).mount();
});
